import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function LogOut() {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen items-center justify-center bg-light-blue-100">
      <div className="grid h-[574px] w-[970px] grid-cols-8 rounded-md bg-white shadow-md">
        <div className="col-span-4 flex items-center justify-center">
          <img src="assets/airselangor-logo.svg" className="h-[105] w-[385px]" alt="" />
        </div>
        <div className="col-span-4 flex w-full flex-col justify-center p-16">
          <div className="flex justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="132"
              height="131"
              viewBox="0 0 132 131"
              fill="none"
            >
              <path
                d="M131.497 65.5029C131.497 78.4576 127.656 91.1214 120.458 101.893C113.261 112.664 103.031 121.06 91.0629 126.017C79.0943 130.975 65.9244 132.272 53.2187 129.744C40.5129 127.217 28.8419 120.979 19.6816 111.818C10.5213 102.658 4.283 90.9871 1.75566 78.2813C-0.771668 65.5756 0.52545 52.4057 5.48299 40.4372C10.4405 28.4686 18.8358 18.2389 29.6072 11.0417C40.3787 3.84444 53.0424 0.00292969 65.9971 0.00292969C74.5987 0.00292969 83.116 1.69714 91.0629 4.98882C99.0097 8.2805 106.23 13.1052 112.313 19.1874C118.395 25.2697 123.22 32.4903 126.511 40.4372C129.803 48.384 131.497 56.9013 131.497 65.5029ZM58.4241 100.183L107.018 51.5889C107.81 50.7964 108.256 49.7216 108.256 48.6009C108.256 47.4802 107.81 46.4054 107.018 45.6129L101.041 39.6369C100.649 39.2445 100.183 38.9331 99.6702 38.7207C99.1576 38.5083 98.608 38.399 98.0531 38.399C97.4982 38.399 96.9486 38.5083 96.436 38.7207C95.9233 38.9331 95.4574 39.2445 95.0651 39.6369L55.4411 79.2669L36.9411 60.7669C36.1486 59.9745 35.0738 59.5294 33.9531 59.5294C32.8324 59.5294 31.7576 59.9745 30.9651 60.7669L24.9821 66.7439C24.1897 67.5364 23.7446 68.6112 23.7446 69.7319C23.7446 70.8526 24.1897 71.9274 24.9821 72.7199L52.4481 100.186C53.2406 100.978 54.3154 101.423 55.4361 101.423C56.5568 101.423 57.6316 100.978 58.4241 100.186V100.183Z"
                fill="#E9F5FD"
              />
            </svg>
          </div>
          <div className="mb-4 py-5 text-center text-[25px] font-bold italic leading-normal text-medium-blue">
            You have been logged out
          </div>

          <div className="mb-[30px] text-center text-[18px] text-medium-grey-100">Thank You</div>
          <div className="mb-[15px] w-full border-b"></div>
          <div className="mb-6">
            <Link to="/login">
              <button
                className="h-[50px] w-full bg-dark-blue-100 text-lg font-bold text-white hover:bg-blue-600"
                type="button"
              >
                Log in
              </button>
            </Link>
          </div>
          <div className="cursor-pointer text-center text-sm text-medium-grey-100">
            <span onClick={() => navigate('/forgot-password')}>Forgot your password?</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogOut;
